<template>
  <div class="descriptionOfGoods">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.FabricReport.BULK_SUMMARY') }}
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.FabricReport.Packed') }}：</span>
      <div class="img">
        <show-img
          :data="descriptionOfGoods.fmediaPacked"
          :otherData="{
            mediaName: '大货成卷卷堆',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'fmediaPacked',
          }"
          :id="id"
        ></show-img>
      </div>
      <!-- <div class="button-group">
        <a-button
          type="primary"
          size="small"
          @click="saveImg(descriptionOfGoods.fmediaPacked, 'fmediaPacked')"
          >保存</a-button
        >
      </div> -->
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.FabricReport.Unpacked') }}：</span>
      <div class="img">
        <show-img
          :data="descriptionOfGoods.fmediaUnpacked"
          :otherData="{
            mediaName: '未成卷产品',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'fmediaUnpacked',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.FabricReport.Packing_List') }}：</span>
      <div class="img">
        <show-img
          :data="descriptionOfGoods.fmediaPackinglist"
          :otherData="{
            mediaName: '码单',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'fmediaPackinglist',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-table">
      <a-table
        class="desOfGoods-table1"
        :columns="columns"
        :dataSource="data"
        bordered
        :pagination="false"
        rowKey="id"
      >
      </a-table>
    </div>
  </div>
</template>
<script>
import showImg from './showImg';
// const columns =
export default {
  data() {
    return {
      columns: [
        {
          title: this.$tc('lang.FabricReport.Color'),
          dataIndex: 'goodsColor',
          key: 'goodsColor',
        },
        {
          title: this.$tc('lang.FabricReport.Ticket_Length'),
          dataIndex: 'goodsTicketlength',
          key: 'goodsTicketlength',
        },
        {
          title: this.$tc('lang.FabricReport.Actual_Length'),
          dataIndex: 'goodsActuallength',
          key: 'goodsActuallength',
        },
        {
          title: this.$tc('lang.FabricReport.Sample_Length'),
          children: [
            {
              title: this.$tc('lang.FabricReport.Packed1'),
              dataIndex: 'goodsPackedlength',
              key: 'goodsPackedlength',
            },
            {
              title: this.$tc('lang.FabricReport.Unpacked1'),
              dataIndex: 'goodsUnpackedlength',
              key: 'goodsUnpackedlength',
            },
          ],
        },
        {
          title: this.$tc('lang.FabricReport.Roll_Qty'),
          children: [
            {
              title: this.$tc('lang.FabricReport.Packed1'),
              dataIndex: 'goodsPackedrollqty',
              key: 'goodsPackedrollqty',
            },
            {
              title: this.$tc('lang.FabricReport.Unpacked1'),
              dataIndex: 'goodsUnpackedrollqty',
              key: 'goodsUnpackedrollqty',
            },
          ],
        },
      ],
      data: [],
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      id: this.$route.query.id,
    };
  },
  components: {
    showImg,
  },
  computed: {
    fabricDetails: {
      get() {
        return JSON.parse(
          JSON.stringify(this.$store.state.report.fabricDetails),
        );
      },
    },
    descriptionOfGoods: {
      get() {
        return JSON.parse(
          JSON.stringify(
            this.$store.state.report.fabricImgList.descriptionOfGoods,
          ),
        );
      },
    },
  },
  created() {
    this.getSelectDate();
  },
  methods: {
    getSelectDate() {
      this.$http
        .post('/hzwmj/fabric-goods/seachFabricGoods', {
          lreportId: this.fabricDetails.freportId,
        })
        .then(data => {
          if (data) {
            this.data = [data.data];
          } else {
            this.data = [];
          }
        })
        .catch(() => {
          this.data = [];
        });
    },
    showModal() {
      this.visible = true;
      setTimeout(() => {
        this.form.setFieldsValue({
          goodsColor: this.data[0].goodsColor || '',
          goodsTicketlength: this.data[0].goodsTicketlength || '',
          goodsActuallength: this.data[0].goodsActuallength || '',
          goodsPackedlength: this.data[0].goodsPackedlength || '',
          goodsUnpackedlength: this.data[0].goodsUnpackedlength || '',
          goodsPackedrollqty: this.data[0].goodsPackedrollqty || '',
          goodsUnpackedrollqty: this.data[0].goodsUnpackedrollqty || '',
        });
      }, 0);
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true;
          this.$http
            .post('/hzwmj/fabric-goods/saveOrUpdateFabricGoods', {
              lreportId: this.fabricDetails.freportId,
              modelType: '2',

              goodsColor: values.goodsColor,
              goodsTicketlength: values.goodsTicketlength,
              goodsActuallength: values.goodsActuallength,
              goodsPackedlength: values.goodsPackedlength,
              goodsUnpackedlength: values.goodsUnpackedlength,
              goodsPackedrollqty: values.goodsPackedrollqty,
              goodsUnpackedrollqty: values.goodsUnpackedrollqty,
            })
            .then(data => {
              if (data) {
                this.$message.success('保存成功');
                this.confirmLoading = false;
                this.visible = false;
                this.getSelectDate();
              } else {
                this.$message.error('保存失败');
                this.confirmLoading = false;
              }
            })
            .catch(() => {
              this.$message.error('保存失败');
              this.confirmLoading = false;
            });
        }
      });
    },
    // saveImg(data, type) {
    saveImg() {
      let fileList = [];
      let fileList1 = [];
      let fileList2 = [];
      // data.forEach(item => {
      //   fileList.push(item.id);
      // });
      this.descriptionOfGoods.fmediaPacked.forEach(item => {
        fileList.push(item.id);
      });
      this.descriptionOfGoods.fmediaUnpacked.forEach(item => {
        fileList1.push(item.id);
      });
      this.descriptionOfGoods.fmediaPackinglist.forEach(item => {
        fileList2.push(item.id);
      });
      var postData = {
        ireportId: this.fabricDetails.freportId,
        imediaName: '大货情况',
        imediaSaveType: '1',
        modelType: '2',
        fmediaPacked: fileList.join(','),
        fmediaUnpacked: fileList1.join(','),
        fmediaPackinglist: fileList2.join(','),
      };
      // postData[type] = fileList.join(',');
      this.$http
        .post('/hzwmj/fabric-media/saveOrUpdateFabricMedia', postData)
        .then(data => {
          if (data) {
            // this.visible = false;
            this.$message.success('保存成功');
            this.$store.dispatch(
              'report/getfabricImg',
              this.fabricDetails.freportId,
            );
          } else {
            this.$message.error('保存失败');
          }
        })
        .catch(() => {
          this.$message.error('保存失败');
        });
    },
  },
};
</script>
<style lang="less">
.descriptionOfGoods {
  .desOfGoods-con {
    display: flex;
    margin-top: 30px;
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
    .img {
      flex-grow: 1;
    }
    > span {
      display: inline-block;
      width: 100px;
      flex-shrink: 0;
      padding-left: 20px;
      // text-align: center;
    }
    // img {
    //   width: 20%;
    //   height: 150px;
    //   margin: 0 20px 20px;
    // }
  }
  .desOfGoods-table {
    display: flex;
    .desOfGoods-table1 {
      flex-grow: 1;
      margin-left: 20px;
      .ant-table-footer {
        padding: 0;
        .footer1 {
          // border-right: 1px solid #e8e8e8;
          width: 30%;
        }
        p {
          display: inline-block;
          padding: 0 16px;
          margin-bottom: 0;
          line-height: 52px;
        }
      }
    }
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
  }
}
</style>
